module.exports = __webpack_public_path__ + "img/view.67bbb05d.svg";